"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Integrations = exports.TariffDimensionType = exports.EDITABLE_OCPI_TOKEN_FLAG_KEYS = exports.EDITABLE_OCPI_TOKEN_FLAGS = exports.OCPISessionStatus = exports.OCPICDRStatus = exports.ImageCategory = void 0;
var ImageCategory;
(function (ImageCategory) {
    ImageCategory["CHARGER"] = "CHARGER";
    ImageCategory["ENTRANCE"] = "ENTRANCE";
    ImageCategory["LOCATION"] = "LOCATION";
    ImageCategory["NETWORK"] = "NETWORK";
    ImageCategory["OPERATOR"] = "OPERATOR";
    ImageCategory["OTHER"] = "OTHER";
    ImageCategory["OWNER"] = "OWNER";
})(ImageCategory = exports.ImageCategory || (exports.ImageCategory = {}));
var OCPICDRStatus;
(function (OCPICDRStatus) {
    OCPICDRStatus["NOT_READY"] = "NOT_READY";
    OCPICDRStatus["READY_TO_SEND"] = "READY_TO_SEND";
    OCPICDRStatus["SENT_SUCCESSFULLY"] = "SENT_SUCCESSFULLY";
    OCPICDRStatus["RETRY_PENDING"] = "RETRY_PENDING";
    OCPICDRStatus["FAILED"] = "FAILED";
})(OCPICDRStatus = exports.OCPICDRStatus || (exports.OCPICDRStatus = {}));
var OCPISessionStatus;
(function (OCPISessionStatus) {
    OCPISessionStatus["HAVENT_SENT"] = "HAVENT_SENT";
    OCPISessionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    OCPISessionStatus["SENT_SUCCESSFULLY"] = "SENT_SUCCESSFULLY";
    OCPISessionStatus["FAILED"] = "FAILED";
    OCPISessionStatus["STOPPING_UPDATES"] = "STOPPING_UPDATES";
    OCPISessionStatus["READY_TO_SEND"] = "READY_TO_SEND";
})(OCPISessionStatus = exports.OCPISessionStatus || (exports.OCPISessionStatus = {}));
/**
 * Every flag the NOC may edit on a credential token, in the order the console renders them.
 *
 * This is the single definition of that set: noc-svc derives the allow-list it filters request
 * bodies against from these keys, and the console derives its columns from the same object, so
 * the two cannot drift. Typing it as a total `Record` over {@link UpdateOCPITokenFlags} means
 * adding a flag to that interface fails to compile until it is described here.
 */
exports.EDITABLE_OCPI_TOKEN_FLAGS = {
    disabled: {
        header: "Disabled",
        helpText: "Turn the partner off without deleting their credentials. Everything we serve or push " +
            "them is marked unpublished and its EVSEs removed, their RFID tokens stop authorizing, and " +
            "they cannot start sessions. Sessions already under way still finish and are still billed.",
    },
    base64EncodeToken: {
        header: "Base64 Encoded",
        helpText: "Base64 encode the token on requests to this partner.",
    },
    supportsPushModel: {
        header: "Push Model",
        helpText: "We push location and tariff updates to this partner.",
    },
    shouldPushConnectors: {
        header: "Push Connectors",
        helpText: "Include connector-level objects in pushes to this partner, and read their copy back to " +
            "reconcile our cache. Off for partners whose Locations module stops at the EVSE level.",
    },
    includeNonPayableSites: {
        header: "Non-Payable Sites",
        helpText: "Send all sites, not only those whose owner org has a matching integration. Remote " +
            "start/RFID capabilities are stripped from sites without a payment integration.",
    },
};
/**
 * The editable flag names, in console order. Derived from {@link EDITABLE_OCPI_TOKEN_FLAGS} so a
 * flag missing there is one the API will reject.
 */
exports.EDITABLE_OCPI_TOKEN_FLAG_KEYS = Object.keys(exports.EDITABLE_OCPI_TOKEN_FLAGS);
/**
 * The dimension a {@link PriceComponent} is priced against (OCPI 2.2.1 TariffDimensionType).
 */
var TariffDimensionType;
(function (TariffDimensionType) {
    /** Defined in kWh, `step_size` multiplier is 1 Wh. */
    TariffDimensionType["ENERGY"] = "ENERGY";
    /** Flat fee without unit for `step_size`. */
    TariffDimensionType["FLAT"] = "FLAT";
    /** Time not charging, defined in hours, `step_size` multiplier is 1 second. */
    TariffDimensionType["PARKING_TIME"] = "PARKING_TIME";
    /** Time charging, defined in hours, `step_size` multiplier is 1 second. */
    TariffDimensionType["TIME"] = "TIME";
})(TariffDimensionType = exports.TariffDimensionType || (exports.TariffDimensionType = {}));
/**
 * IF YOU MODIFY THIS:
 * Make sure to update the INTEGRATION_TO_OCPI_INFO_LOOKUP map in wave/libraries/ee-utils/src/ocpi.ts
 *
 * Typeorm does not seem to like editing this enum when it is used in two tables: the
 * resulting migration may need to be edited by hand.
 */
var Integrations;
(function (Integrations) {
    Integrations["WEX"] = "WEX";
    Integrations["HUBJECT"] = "HUBJECT";
    Integrations["MONTA"] = "MONTA";
    Integrations["OCTOPUS"] = "OCTOPUS";
})(Integrations = exports.Integrations || (exports.Integrations = {}));
